var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchPair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 107,
    viewBox: "0 0 96 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4084 94.9205L13.1316 101.619L-11 22.866L71.8684 0L96 78.7533L47.4573 92.1477V107.001H37.4084V94.9205ZM37.4084 84.9537L19.9253 89.7827L1.45503 29.3896L65.004 11.8365L83.4742 72.2297L47.4573 82.178V62.6812H37.4084V84.9537ZM35.1438 50.8446C35.1438 46.944 38.3284 43.9176 42.4329 43.9176C46.4666 43.9176 49.6511 46.944 49.7219 50.8446C49.7219 54.7453 46.5373 57.7717 42.4329 57.7717C38.3284 57.7717 35.1438 54.7453 35.1438 50.8446Z",
    fill: "#E7F0FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchPair2);
export default __webpack_public_path__ + "static/media/match_pair2.81977c7d35c4af0ff4e82f800b9c2061.svg";
export { ForwardRef as ReactComponent };